<h2 app-landing-page-title i18n="@@landingPage.admin.title">Admin</h2>

<mat-card>
  <mat-card-header>
    <mat-card-title>
      <persistent-simple-text-section-entity section="landingPage.admin.title">
      </persistent-simple-text-section-entity>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <persistent-rich-text-section-entity section="landingPage.admin.text"></persistent-rich-text-section-entity>
  </mat-card-content>
</mat-card>